var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$userInfo.isSystemAdministrator
      ? _c(
          "div",
          [
            _c("app-detail-header", {
              ref: "sectionHeader",
              attrs: { "show-spinner": false },
            }),
            _c(
              "section",
              {
                staticClass: "container",
                staticStyle: { "margin-top": "1em" },
              },
              [
                _c("div", { staticClass: "columns" }, [
                  _c("div", { staticClass: "field has-addons column" }, [
                    _c("p", { staticClass: "control has-icons-left" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filterKeyword,
                            expression: "filterKeyword",
                          },
                        ],
                        staticClass: "input is-primary",
                        attrs: {
                          id: "filter",
                          type: "text",
                          placeholder: "Filter",
                        },
                        domProps: { value: _vm.filterKeyword },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.filterKeyword = $event.target.value
                          },
                        },
                      }),
                      _vm._m(0),
                    ]),
                    _c("p", { staticClass: "control" }, [
                      _c("span", { staticClass: "select is-primary" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.active,
                                expression: "active",
                              },
                            ],
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.active = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          [
                            _c("option", { domProps: { value: true } }, [
                              _vm._v("Active"),
                            ]),
                            _c("option", { domProps: { value: false } }, [
                              _vm._v("Inactive"),
                            ]),
                            _c("option", { domProps: { value: null } }, [
                              _vm._v("All"),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "field has-addons column is-narrow" },
                    [
                      _c("p", { staticClass: "control" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-warning",
                            on: {
                              click: function ($event) {
                                return _vm.sortData(_vm.sort, _vm.sortDesc)
                              },
                            },
                          },
                          [_vm._v(" Sort ")]
                        ),
                      ]),
                      _c("p", { staticClass: "control" }, [
                        _c("span", { staticClass: "select is-warning" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.sort,
                                  expression: "sort",
                                },
                              ],
                              on: {
                                change: [
                                  function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.sort = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                  function ($event) {
                                    return _vm.sortData(_vm.sort, _vm.sortDesc)
                                  },
                                ],
                              },
                            },
                            [
                              _c("option", { attrs: { value: "name" } }, [
                                _vm._v("Name"),
                              ]),
                              _c("option", { attrs: { value: "code" } }, [
                                _vm._v("Code Name"),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                      _c("p", { staticClass: "control" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-warning",
                            on: {
                              click: function ($event) {
                                return _vm.sortData(_vm.sort, !_vm.sortDesc)
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "icon" }, [
                              _c("i", {
                                staticClass: "mdi",
                                class: {
                                  "mid-arrow-down-circle": _vm.sortDesc,
                                  "mdi-arrow-up-circle": !_vm.sortDesc,
                                },
                              }),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
                _c(
                  "ul",
                  _vm._l(_vm.filteredPermissionRecords, function (p, idx) {
                    return _c(
                      "li",
                      { key: idx, staticClass: "boxy list-complete-item" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "columns box-head",
                            staticStyle: {
                              "border-bottom": "1px dotted #c3c3c3",
                            },
                          },
                          [
                            _c("div", { staticClass: "column" }, [
                              _c("h2", { staticClass: "subtitle is-5" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: p.name,
                                      expression: "p.name",
                                    },
                                  ],
                                  staticClass: "input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Module Name",
                                    required: "",
                                  },
                                  domProps: { value: p.name },
                                  on: {
                                    change: function ($event) {
                                      return _vm.updateAccess(p)
                                    },
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(p, "name", $event.target.value)
                                    },
                                  },
                                }),
                              ]),
                            ]),
                            _c("div", { staticClass: "column is-narrow" }, [
                              _c("div", { staticClass: "field has-addons" }, [
                                _c("p", { staticClass: "control" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: p.codeName,
                                        expression: "p.codeName",
                                      },
                                    ],
                                    staticClass: "input",
                                    attrs: {
                                      type: "text",
                                      placeholder: "Code Name",
                                      required: "",
                                    },
                                    domProps: { value: p.codeName },
                                    on: {
                                      change: function ($event) {
                                        return _vm.updateAccess(p)
                                      },
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          p,
                                          "codeName",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                                _c("p", { staticClass: "control" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "button",
                                      on: {
                                        click: function ($event) {
                                          p.isActive = !p.isActive
                                        },
                                      },
                                    },
                                    [
                                      _c("span", { staticClass: "icon" }, [
                                        _c("i", {
                                          staticClass: "mdi mdi-20px",
                                          class: [
                                            p.isActive
                                              ? "mdi-trash-can-outline"
                                              : "mdi-lifebuoy",
                                          ],
                                          staticStyle: { color: "#c3c3c3" },
                                        }),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                        _c("permission-record-versions", {
                          attrs: {
                            "permission-record-id": p.id,
                            versions: p.versions,
                          },
                          on: {
                            accessChanged: function ($event) {
                              return _vm.updateAccess(p)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]
            ),
          ],
          1
        )
      : _c("div", { staticClass: "is-flex is-justify-content-center pt-5" }, [
          _c(
            "div",
            {
              staticClass:
                "notification is-danger is-flex is-justify-content-center is-size-4",
              staticStyle: { width: "50%" },
            },
            [_vm._v(" You do not have permissions on this page ")]
          ),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-left" }, [
      _c("i", { staticClass: "mdi mdi-magnify mdi-20px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }